import { useCallback, useState } from 'react';

export const useDrawer = <T>(drawerData?: T) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [data, setData] = useState<T | undefined>(drawerData);

  const open = useCallback((data?: T) => {
    if (data) setData(data);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const toggle = useCallback((data?: T) => {
    if (data) setData(data);
    setIsOpen(curr => !curr);
  }, []);

  return {
    isOpen,
    setIsOpen,
    data,
    setData,
    open,
    close,
    toggle,
  };
};
